import { createFileRoute } from "@tanstack/react-router";
import SystemIndex from "@/components/System/SystemIndex";

export const Route = createFileRoute("/_auth/_kontrollpunktselect/kontrollpunkter/")({
  component: SystemIndex,
});
